module.exports = require('happened').create({
    scheduler: setImmediate
});



//////////////////
// WEBPACK FOOTER
// ./packages/z-shop-event-bus/index.js
// module id = 212
// module chunks = 0